import MagnificPopup, { IPopup, PopupOptions, PopupWidth } from "./popup";
import { localize } from "./common";

export default class ErrorPopup {
    private popup: IPopup;

    private popupId = 'message-dialogue';

    constructor(){
        this.popup = new MagnificPopup(<PopupOptions> { id: this.popupId, width: PopupWidth.Small })
    }

    public display(message: string, title: string = null){
        if(this.popup.isOpen) {
            this.popup.close();
        }

        this.popup.open(this.getErrorDialog(message, title ?? localize('Warning')));

        this.addCloseButtonListener();

    }

    private addCloseButtonListener() {
        const dialog = document.querySelector(`#${this.popupId}`);
        if(!dialog){
            return;
        }
        
        const closeButton = dialog.querySelector('[data-component-part="close-button"]');
        
        if(closeButton){
            closeButton.addEventListener('click', () => this.popup.close());
        }
    }

    private getErrorDialog(message: string, title: string): string {
        return  `
            <div class="message-dialogue">
                <h2 class="message-dialogue__caption">${title}</h2>
                <div class="message-dialogue__text">
                    <p>${message}</p>
                </div>
                <div class="message-dialogue__controls">
                    <a href="#" class="message-dialogue__button configurable-base-primary" data-component-part="close-button">
                        <span>${localize('Close')}</span>
                    </a>
                </div>
            </div>
            <button aria-label="Close" title="Close (Esc)" type="button" class="mfp-close">×</button>`
    }
}
